import { Color } from "./Color";

export const RoundedCorners = `
-webkit-border-radius: .5rem;
-moz-border-radius: .5rem;
border-radius: .5rem;`;

export const RoundedTopCorners = `
-webkit-border-top-left-radius: .5rem;
-webkit-border-top-right-radius: .5rem;
-moz-border-radius-topleft: .5rem;
-moz-border-radius-topright: .5rem;
border-top-left-radius: .5rem;
border-top-right-radius: .5rem;`;

export const RoundedBottomCorners = `
-webkit-border-bottom-left-radius: .5rem;
-webkit-border-bottom-right-radius: .5rem;
-moz-border-radius-bottomleft: .5rem;
-moz-border-radius-bottomright: .5rem;
border-bottom-left-radius: .5rem;
border-bottom-right-radius: .5rem;`;

export const DropShadowBlack = `
box-shadow: ${Color.BlackShadow} 0rem 0rem .5rem 0rem;
`;

export const DropShadowBlack1 = `
box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
`;

export const DropShadowBlack2 = `
box-shadow: ${Color.BlackShadow2} 0rem 0.5rem 2rem 0rem;
`;

export const DropShadowOrange = `
box-shadow: ${Color.OrangeShadow} 0rem 0.5rem 2rem 0rem;
`;
